import { BunnyPicture } from "@/common/components/bunny-picture";
import { cn } from "@/common/utils/css.utils";
import { useProductCard } from "@/features/search/components/product-card/product-card.context";

const SIZES = [
  { media: "(max-width: 768px)", width: "256px" },
  { media: "(min-width: 769px)", width: "512px" },
];

type ProductCardImageProps = {
  /** Preload the image (use for above-the-fold cards to help LCP). */
  priority?: boolean;
};

/**
 * Square, contained product image. Crossfades to the second photo on hover when
 * one exists — purely presentational, driven by the parent card's `group`.
 */
export const ProductCardImage = ({ priority }: ProductCardImageProps) => {
  const { product } = useProductCard();
  const [primary, secondary] = product.images;

  return (
    <div className="product-card-image">
      {primary && (
        <BunnyPicture
          preload={priority}
          draggable={false}
          className="absolute inset-0"
          imgClassName={cn(
            "product-card-image-primary",
            /* Dimmed when sold. */
            product.sold && "opacity-50",
            secondary && "group-hover:opacity-0"
          )}
          src={primary.url}
          width={primary.width ?? 0}
          height={primary.height ?? 0}
          sizes={SIZES}
          alt={product.title}
        />
      )}
      {secondary && (
        <BunnyPicture
          draggable={false}
          className={cn(
            "product-card-image-secondary",
            product.sold ? "group-hover:opacity-50" : "group-hover:opacity-100"
          )}
          imgClassName="h-full w-full object-cover"
          src={secondary.url}
          width={secondary.width ?? 0}
          height={secondary.height ?? 0}
          sizes={SIZES}
          alt=""
        />
      )}
    </div>
  );
};
